import React from "react";

import Slider from "@material-ui/core/Slider";
import { withStyles } from "@material-ui/core/styles";

const StyledSlider = withStyles((theme) => {
  return {
    /* Styles applied to the root element. */
    root: {
      "&$vertical": {
        width: 0,
        margin: 0,
        paddingLeft: 20,
        paddingRight: 20,
        [theme.breakpoints.up("sm")]: {
          height: 120,
        },
      },
      [theme.breakpoints.down("sm")]: {
        "&$vertical": {
          height: 80,
        },
      },
    },
    marked: {
      marginBottom: 20,
      "&$vertical": {
        marginBottom: "auto",
        marginLeft: 20,
      },
    },
    mark: {
      display: "none",
    },
    vertical: {},
    markLabel: {
      "$vertical &": {
        left: 0,
      },
      "@media (pointer: coarse)": {
        "$vertical &": {
          left: 0,
        },
      },
    },
  };
})(Slider);

export default function HexagonMapSlider({ onChange, value }) {
  const handleResolutionChange = (_, value) => {
    onChange(value);
  };

  return (
    <StyledSlider
      orientation="vertical"
      onChange={handleResolutionChange}
      value={value}
      aria-labelledby="discrete-slider-small-steps"
      valueLabelDisplay="off"
      step={1}
      marks={[
        {
          value: 6,
          label: "L",
        },
        {
          value: 7,
          label: "M",
        },
        {
          value: 8,
          label: "S",
        },
      ]}
      min={6}
      max={8}
    />
  );
}
